import styled from "styled-components";

export const Image = styled.div`
  width: 42px;
  margin: 0px 25px;
  img {
    max-width: 42px;
  }
`;
